// oxlint-disable-next-line no-restricted-imports
import { useServerFn as useStartServerFn } from "@tanstack/react-start";

// oxlint-disable-next-line typescript/no-explicit-any -- mirrors the upstream hook constraint
type ServerFn = (...args: any[]) => Promise<any>;

/**
 * `useServerFn` with an honest return type. When the server fn throws a `redirect` (expired
 * session, version skew, import restart), TanStack's hook navigates and resolves with the
 * `router.navigate` result instead of the fn's payload, while its type still claims the payload.
 * Callers that read the result must handle `undefined` — the navigation is already under way.
 */
export function useServerFn<T extends ServerFn>(
  serverFn: T,
): (...args: Parameters<T>) => Promise<Awaited<ReturnType<T>> | undefined> {
  return useStartServerFn(serverFn);
}
